import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block"
    >
      <div className={`relative overflow-hidden rounded-xl bg-background-100 transition-transform duration-300 group-hover:scale-[1.02] ${
        size === 'large' ? 'aspect-[16/9]' : 'aspect-[2/3]'
      }`}>
        <img
          src={movie.poster}
          alt={movie.title}
          title={`${movie.title} - 高清电影在线观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="absolute top-3 left-3 flex flex-col gap-2">
          {movie.isNew && (
            <span className="px-2.5 py-1 bg-accent-500 text-foreground-50 text-xs font-medium rounded-md">
              NEW
            </span>
          )}
          {movie.isHot && (
            <span className="px-2.5 py-1 bg-primary-500 text-background-950 text-xs font-medium rounded-md">
              热播
            </span>
          )}
        </div>

        <div className="absolute top-3 right-3">
          <div className="flex items-center gap-1 px-2 py-1 bg-background-950/70 backdrop-blur-sm rounded-md">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-primary-400 text-xs"></i>
            </div>
            <span className="text-foreground-100 text-xs font-semibold">{movie.rating}</span>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
          <h3 className="text-sm font-semibold text-foreground-100 mb-1 line-clamp-1">{movie.title}</h3>
          <p className="text-xs text-foreground-400 line-clamp-1">{movie.year} · {movie.category} · {movie.duration}</p>
        </div>
      </div>
    </Link>
  );
}